import { createAction } from 'redux-act';

export const loadDecisionMaker = createAction();
export const decisionMakerLoaded = createAction();